import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const useCart = create(
  persist(
    (set, get) => ({
      cart: [],
      sessionId: null,
      isLoading: false,

      initSession: () => {
        const sessionId = get().sessionId || `session_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;
        set({ sessionId });
        return sessionId;
      },

      fetchCart: async () => {
        const sessionId = get().sessionId || get().initSession();
        try {
          const response = await axios.get(`${API}/cart/items/${sessionId}`);
          set({ cart: response.data.items || [] });
        } catch (error) {
          console.error('Error fetching cart:', error);
        }
      },

      addItem: async (product, quantity = 1, bundleCustomization = null) => {
        const sessionId = get().sessionId || get().initSession();
        set({ isLoading: true });
        try {
          const payload = {
            product_id: product.id,
            quantity
          };
          if (bundleCustomization) {
            payload.bundle_customization = bundleCustomization;
          }
          await axios.post(`${API}/cart/add?session_id=${sessionId}`, payload);
          await get().fetchCart();
          return true;
        } catch (error) {
          console.error('Error adding to cart:', error);
          return false;
        } finally {
          set({ isLoading: false });
        }
      },

      removeItem: async (productId) => {
        const sessionId = get().sessionId;
        if (!sessionId) return;
        try {
          await axios.delete(`${API}/cart/remove/${sessionId}/${productId}`);
          await get().fetchCart();
        } catch (error) {
          console.error('Error removing from cart:', error);
        }
      },

      updateQuantity: async (productId, quantity) => {
        const sessionId = get().sessionId;
        if (!sessionId) return;
        try {
          await axios.put(`${API}/cart/update/${sessionId}/${productId}?quantity=${quantity}`);
          await get().fetchCart();
        } catch (error) {
          console.error('Error updating cart:', error);
        }
      },

      clearCart: () => set({ cart: [] }),

      getTotal: () => {
        return get().cart.reduce((total, item) => total + (item.price * item.quantity), 0);
      },

      getItemCount: () => {
        return get().cart.reduce((count, item) => count + item.quantity, 0);
      }
    }),
    {
      name: 'cart-storage',
      partialize: (state) => ({ sessionId: state.sessionId, cart: state.cart })
    }
  )
);

export default useCart;